export const KEY = 'teste_key';

export const LOCAL_STORAGE_AUTH = {
  USER_INFO: 'x-soil-session',
};
